<script>
  import moment from 'moment';
  import DatePicker from 'vue2-datepicker';
  import conciliacaoProjetoServico from '../servico';

  const ROTULO_MOTIVO = {
    fornecedor: 'Crédito de fornecedor',
    terceiro: 'Crédito de terceiro',
    credito_terceiro: 'Crédito de terceiro',
    interno: 'Crédito interno',
    duplicado: 'Já importado',
    dia_outro_arquivo: 'Dia veio de outro arquivo',
    fora_do_escopo: 'Fora do escopo',
    credito_com_contraparte_no_ext: 'Crédito de terceiro — vem no extrato individual',
    outro: 'Outro',
  };

  export default {
    components: { DatePicker },
    data() {
      return {
        carregando: false,
        animated: true,
        dataIni: moment().subtract(7, 'days').toDate(),
        dataFim: moment().toDate(),
        motivo: '',
        busca: '',
        soSemExtrato: false,
        todos: false,
        expandidos: {},
        resumo: { qtde: 0, qtdeContas: 0, qtdeDias: 0, valor: 0, semExtrato: 0, dias: [], motivos: [] },
      }
    },
    computed: {
      dias() {
        const texto = (this.busca || '').trim().toLowerCase();
        if (!texto) return this.resumo.dias || [];

        const dias = [];
        (this.resumo.dias || []).forEach(dia => {
          const contas = [];
          (dia.contas || []).forEach(conta => {
            const linhas = (conta.linhas || []).filter(l => this.casaBusca(l, conta, texto));
            if (linhas.length === 0) return;
            contas.push(Object.assign({}, conta, {
              linhas: linhas,
              qtde: linhas.length,
              valor: linhas.reduce((s, l) => s + (l.valor || 0), 0),
            }));
          });
          if (contas.length === 0) return;
          dias.push(Object.assign({}, dia, {
            contas: contas,
            qtdeContas: contas.length,
            qtde: contas.reduce((s, c) => s + c.qtde, 0),
            valor: contas.reduce((s, c) => s + c.valor, 0),
          }));
        });
        return dias;
      },
      temFiltro() { return !!this.motivo || this.soSemExtrato || !!(this.busca || '').trim(); },
      periodoTexto() {
        if (!this.dataIni || !this.dataFim) return '';
        return moment(this.dataIni).format('DD/MM') + ' – ' + moment(this.dataFim).format('DD/MM/YYYY');
      },
      motivosDisponiveis() { return this.resumo.motivos || []; },
      totalLinhas() { return this.dias.reduce((s, d) => s + d.qtde, 0); },
      totalValor() { return this.dias.reduce((s, d) => s + d.valor, 0); },
      totalDias() { return this.dias.length; },
      totalContas() {
        const chaves = {};
        this.dias.forEach(d => d.contas.forEach(c => { chaves[c.idConta + '|' + c.numeroConta] = true; }));
        return Object.keys(chaves).length;
      },
      contasSemExtrato() {
        const chaves = {};
        this.dias.forEach(d => d.contas.forEach(c => { if (!c.temExtratoImportado) chaves[c.idConta + '|' + c.numeroConta] = true; }));
        return Object.keys(chaves).length;
      },
      valorSemExtrato() {
        let total = 0;
        this.dias.forEach(d => d.contas.forEach(c => { if (!c.temExtratoImportado) total += c.valor; }));
        return total;
      },
    },
    mounted() {
      this.carregar();
    },
    methods: {
      casaBusca(linha, conta, texto) {
        const campos = [linha.historico, linha.documento, conta.nomeConta, conta.numeroConta, linha.nomeContraparte];
        for (let i = 0; i < campos.length; i++) {
          if ((campos[i] || '').toLowerCase().indexOf(texto) >= 0) return true;
        }
        return false;
      },
      situacao(conta) {
        if (!conta.temExtratoImportado) return { classe: 'ign-chip-alerta', texto: 'falta importar o extrato individual' };
        if (conta.linhasForaDoExtrato > 0) return { classe: 'ign-chip-info', texto: 'extrato do dia já importado' };
        return { classe: 'ign-chip-ok', texto: 'linhas já no extrato' };
      },
      rotuloMotivo(m) {
        if (ROTULO_MOTIVO[m]) return ROTULO_MOTIVO[m];
        const texto = (m || '').replace(/[_-]+/g, ' ').trim();
        return texto ? texto.charAt(0).toUpperCase() + texto.slice(1) : 'Outro';
      },
      formatar(v) { return (v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); },
      diaPorExtenso(dia) {
        const data = moment(dia.data, 'DD/MM/YYYY');
        return data.isValid() ? data.format('ddd, DD/MM/YYYY') : dia.data;
      },
      chaveConta(dia, conta) { return dia.dataMovimento + '-' + (conta.idConta || conta.numeroConta); },
      expandido(dia, conta) { return !!this.expandidos[this.chaveConta(dia, conta)]; },
      alternar(dia, conta) {
        const chave = this.chaveConta(dia, conta);
        this.$set(this.expandidos, chave, !this.expandidos[chave]);
      },
      carregar() {
        this.carregando = true;
        const filtros = {
          dataIni: this.dataIni ? moment(this.dataIni).format('YYYY-MM-DD') : '',
          dataFim: this.dataFim ? moment(this.dataFim).format('YYYY-MM-DD') : '',
          motivo: this.motivo,
          soSemExtrato: this.soSemExtrato,
        };
        return conciliacaoProjetoServico.ignoradas(filtros, this.todos)
          .then(dados => { this.resumo = dados; this.carregando = false; this.expandidos = {}; })
          .catch(() => { this.carregando = false; toastr.error('Não foi possível carregar os créditos ignorados.'); });
      },
      limparFiltros() {
        this.motivo = '';
        this.busca = '';
        this.soSemExtrato = false;
        this.carregar();
      },
      verSemExtrato() {
        if (this.soSemExtrato) return;
        this.soSemExtrato = true;
        this.carregar();
      },
      abrirConciliacao(conta) {
        if (!conta.idContaCript) return;
        this.$router.push({ name: 'conciliacao-banco.tela', params: { idContaCript: conta.idContaCript } });
      },
      voltar() { this.$emit('fechar'); },
    },
  }
</script>

<template>
  <div class="ign ign-ov">

    <div class="ign-box">

      <div class="ign-head">
        <div>
          <h2 class="no-margins ign-titulo">
            Créditos ignorados na importação
            <span class="ign-periodo mono" v-if="periodoTexto">{{ periodoTexto }}</span>
          </h2>
          <div class="ign-sub">
            Linhas do arquivo do banco que a importação descartou, agrupadas por dia e por conta —
            comece pelas contas <strong class="txt-alerta">que faltam importar</strong>: são as que precisam
            do extrato individual no banco.
          </div>
        </div>
      </div>

      <div class="ign-kpis">
        <div class="ign-kpi">
          <div class="ign-kpi-lbl">Linhas ignoradas</div>
          <div><span class="ign-kpi-num mono">{{ totalLinhas }}</span> <span class="ign-kpi-qlf">em {{ totalDias }} dia(s)</span></div>
        </div>
        <div class="ign-kpi">
          <div class="ign-kpi-lbl">Valor fora da conciliação</div>
          <div><span class="ign-kpi-num mono">R$ {{ formatar(totalValor) }}</span></div>
        </div>
        <div class="ign-kpi">
          <div class="ign-kpi-lbl">Contas afetadas</div>
          <div><span class="ign-kpi-num mono">{{ totalContas }}</span> <span class="ign-kpi-qlf">no período</span></div>
        </div>
        <div class="ign-kpi" :class="{ 'ign-kpi-acao': contasSemExtrato > 0 }">
          <div>
            <div class="ign-kpi-lbl">Precisam do extrato individual</div>
            <div>
              <span class="ign-kpi-num mono">{{ contasSemExtrato }}</span>
              <span class="ign-kpi-qlf">conta(s) · R$ {{ formatar(valorSemExtrato) }}</span>
            </div>
          </div>
          <button v-if="contasSemExtrato > 0 && !soSemExtrato" type="button" class="btn btn-xs ign-btn-acao" @click="verSemExtrato">
            Ver essas contas
          </button>
        </div>
      </div>

      <div class="ign-filtros">
        <div class="ign-f">
          <label class="ign-f-lbl">Período</label>
          <div class="ign-f-periodo">
            <date-picker v-model="dataIni" format="DD/MM/YYYY" lang="pt-br" input-class="form-control"
                         :editable="false" :shortcuts="false" :clearable="false" style="width:118px" @change="carregar"></date-picker>
            <span class="ign-ate">até</span>
            <date-picker v-model="dataFim" format="DD/MM/YYYY" lang="pt-br" input-class="form-control"
                         :editable="false" :shortcuts="false" :clearable="false" style="width:118px" @change="carregar"></date-picker>
          </div>
        </div>
        <div class="ign-f">
          <label class="ign-f-lbl">Motivo</label>
          <select class="form-control" style="width:250px" v-model="motivo" @change="carregar">
            <option value="">Todos os motivos</option>
            <option v-for="m in motivosDisponiveis" :value="m" :key="m">{{ rotuloMotivo(m) }}</option>
          </select>
        </div>
        <div class="ign-f ign-f-busca">
          <label class="ign-f-lbl">Buscar</label>
          <div class="ign-busca-wrap">
            <i class="fa fa-search"></i>
            <input type="text" class="form-control" v-model="busca" placeholder="Histórico, documento ou conta">
          </div>
        </div>
        <div class="ign-f">
          <label class="ign-f-lbl">&nbsp;</label>
          <label class="ign-toggle" :class="{ 'ign-toggle-on': soSemExtrato }">
            <input type="checkbox" v-model="soSemExtrato" @change="carregar"> Só contas que faltam importar
          </label>
        </div>
        <div class="ign-f">
          <label class="ign-f-lbl">&nbsp;</label>
          <button type="button" class="btn" :class="temFiltro ? 'btn-warning' : 'btn-white'" :disabled="!temFiltro" @click="limparFiltros">
            <i class="fa fa-eraser"></i> Limpar filtros
          </button>
        </div>
      </div>

      <div v-if="carregando" class="text-center ign-vazio"><i class="fa fa-spinner fa-pulse fa-2x"></i></div>

      <div v-else-if="dias.length === 0" class="ign-vazio">
        <div class="ign-vazio-t">Nenhuma conta corresponde aos filtros</div>
        <div class="ign-vazio-s">Ajuste o período, o motivo, a busca ou desmarque “Só contas que faltam importar”.</div>
      </div>

      <div v-else class="ign-lista">
        <div v-for="dia in dias" :key="dia.dataMovimento">
          <div class="ign-dia">
            <div><i class="fa fa-calendar"></i> {{ diaPorExtenso(dia) }}</div>
            <div class="ign-dia-res mono">
              {{ dia.qtdeContas }} conta(s) · {{ dia.qtde }} linha(s)
              <strong>R$ {{ formatar(dia.valor) }}</strong>
            </div>
          </div>

          <div v-for="conta in dia.contas" :key="chaveConta(dia, conta)">
            <div class="ign-conta" :class="{ 'ign-conta-alerta': !conta.temExtratoImportado }" @click="alternar(dia, conta)">
              <div class="ign-c-chevron"><i class="fa" :class="expandido(dia, conta) ? 'fa-caret-down' : 'fa-caret-right'"></i></div>
              <div class="ign-c-conta">
                <span class="ign-c-nome mono">{{ conta.numeroConta || conta.nomeConta || '(conta não identificada)' }}</span>
                <span class="ign-c-desc">{{ conta.nomeConta }}</span>
                <span v-if="!conta.contaCadastrada" class="label label-danger m-l-xs">não cadastrada</span>
              </div>
              <div class="ign-c-qtde mono">{{ conta.qtde }} linha{{ conta.qtde > 1 ? 's' : '' }}</div>
              <div class="ign-c-valor mono" :class="{ 'txt-alerta': !conta.temExtratoImportado }">R$ {{ formatar(conta.valor) }}</div>
              <div>
                <span class="ign-chip" :class="situacao(conta).classe">
                  <i class="fa fa-circle"></i>
                  {{ situacao(conta).texto }}
                </span>
              </div>
              <div class="text-right">
                <button v-if="conta.idContaCript" type="button" class="btn btn-primary btn-abrir" @click.stop="abrirConciliacao(conta)">
                  Abrir conciliação <i class="fa fa-arrow-right"></i>
                </button>
              </div>
            </div>

            <div v-if="expandido(dia, conta)" class="ign-detalhe">
              <div class="ign-d-head">
                <div>Histórico</div>
                <div>Documento</div>
                <div class="text-right">Valor</div>
                <div>Motivo de ter sido ignorado</div>
              </div>
              <div v-for="l in conta.linhas" :key="l.idExtratoLinhaIgnorada" class="ign-d-linha">
                <div class="ign-d-hist" :title="l.historico">{{ l.historico }}</div>
                <div class="mono">{{ l.documento }}</div>
                <div class="text-right mono" :class="l.creditoDebito === 2 ? 'txt-alerta' : 'txt-ok'">R$ {{ formatar(l.valor) }}</div>
                <div>
                  <span class="ign-tag" :class="conta.temExtratoImportado ? 'ign-tag-neutra' : 'ign-tag-alerta'">{{ rotuloMotivo(l.motivo) }}</span>
                  <div v-if="l.detalhe" class="ign-d-det">{{ l.detalhe }}</div>
                </div>
              </div>
              <div class="ign-d-rodape">
                <div>
                  <template v-if="!conta.temExtratoImportado">Sem par possível: o extrato individual desta conta não foi importado neste dia.</template>
                  <template v-else-if="conta.linhasForaDoExtrato > 0">O extrato deste dia já foi importado por outro arquivo — estas linhas foram descartadas para não duplicar.</template>
                  <template v-else>Estas linhas foram cortadas do arquivo, mas já entraram no extrato desta conta.</template>
                </div>
                <div class="mono">
                  <i class="fa fa-file-o"></i>
                  {{ (conta.linhas[0] && conta.linhas[0].arquivo) || 'nenhum arquivo importado' }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="ign-rodape">
        <div class="ign-rodape-txt">
          Créditos ignorados não entram no saldo conciliado. Importe o extrato individual da conta para que voltem à conciliação.
        </div>
        <div class="ign-rodape-btns">
          <button type="button" class="ign-btn ign-sair" @click="voltar"><i class="fa fa-sign-out"></i> Sair</button>
        </div>
      </div>

    </div>
  </div>
</template>

<style scoped>
  .ign .mono { font-family: Menlo, Consolas, monospace; font-variant-numeric: tabular-nums; }
  .txt-alerta { color: #a13c3c; }
  .txt-ok { color: #0a6d4d; }

  .ign-ov { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(16,24,40,.55); z-index: 1050; display: flex; align-items: center; justify-content: center; padding: 20px; }
  .ign-box { width: 1320px; max-width: 96vw; height: 92vh; display: flex; flex-direction: column;
             background: #fff; border: 1px solid #d3d8de; border-radius: 10px; overflow: hidden; padding: 0;
             box-shadow: 0 16px 48px rgba(16,24,40,.35); }
  .ign-head, .ign-kpis, .ign-filtros, .ign-rodape { flex: 0 0 auto; }

  .ign-head { display: flex; justify-content: space-between; align-items: flex-start; gap: 16px; padding: 16px 18px 14px; }
  .ign-titulo { font-size: 21px; font-weight: 600; letter-spacing: -.01em; }
  .ign-periodo { font-size: 11px; padding: 2px 6px; border-radius: 4px; background: #eef1f4; color: #5b6570; vertical-align: middle; }
  .ign-sub { font-size: 12.5px; color: #6b747e; max-width: 760px; margin-top: 5px; }

  .ign-kpis { display: grid; grid-template-columns: 1fr 1fr 1fr 1.5fr; gap: 1px; background: #e6e9ed; border-top: 1px solid #dfe3e8; border-bottom: 1px solid #dfe3e8; }
  .ign-kpi { background: #fff; padding: 12px 18px; display: flex; justify-content: space-between; align-items: center; gap: 10px; }
  .ign-kpi-lbl { font-size: 10.5px; font-weight: 600; text-transform: uppercase; letter-spacing: .05em; color: #7b848e; margin-bottom: 3px; }
  .ign-kpi-num { font-size: 20px; font-weight: 600; color: #1c2024; }
  .ign-kpi-qlf { font-size: 11.5px; color: #8a939c; margin-left: 5px; }
  .ign-kpi-acao { background: #fdf7f7; border-left: 2px solid #c98080; }
  .ign-kpi-acao .ign-kpi-lbl, .ign-kpi-acao .ign-kpi-num, .ign-kpi-acao .ign-kpi-qlf { color: #a13c3c; }
  .ign-btn-acao { background: #fff; border: 1px solid #c98080; color: #a13c3c; white-space: nowrap; }
  .ign-btn-acao:hover { background: #fbeeee; color: #a13c3c; }

  .ign-filtros { display: flex; align-items: flex-end; gap: 14px; padding: 13px 18px; background: #f7f9fa; border-bottom: 1px solid #dfe3e8; flex-wrap: wrap; }
  .ign-f { display: flex; flex-direction: column; gap: 5px; }
  .ign-f-busca { flex: 1; min-width: 220px; }
  .ign-f-lbl { font-size: 11px; font-weight: 600; text-transform: uppercase; letter-spacing: .04em; color: #7b848e; margin: 0; }
  .ign-f-periodo { display: flex; align-items: center; gap: 8px; }
  .ign-ate { font-size: 12.5px; color: #8a939c; }
  .ign-busca-wrap { position: relative; }
  .ign-busca-wrap .fa-search { position: absolute; left: 10px; top: 11px; font-size: 13px; color: #8a939c; }
  .ign-busca-wrap .form-control { padding-left: 30px; }
  .ign-toggle { display: inline-flex; align-items: center; gap: 7px; height: 34px; padding: 0 11px; margin: 0; border: 1px solid #c6ccd4; border-radius: 5px; background: #fff; font-weight: 400; color: #3b444d; cursor: pointer; user-select: none; }
  .ign-toggle input { margin: 0; }
  .ign-toggle-on { background: #fbeeee; border-color: #e4c9c9; color: #a13c3c; }

  .ign-lista { flex: 1 1 auto; min-height: 0; overflow: auto; background: #fff; }

  .ign-dia { position: sticky; top: 0; z-index: 3; display: flex; justify-content: space-between; align-items: center; padding: 9px 18px; background: #eef1f4; border-bottom: 1px solid #dfe3e8; font-size: 13.5px; font-weight: 600; }
  .ign-dia-res { font-size: 12px; font-weight: 400; color: #6b747e; }
  .ign-dia-res strong { font-size: 13px; color: #1c2024; margin-left: 8px; }

  .ign-conta { display: grid; grid-template-columns: 26px 1.6fr 92px 150px 1fr 170px; gap: 10px; align-items: center; padding: 11px 18px; border-bottom: 1px solid #eef1f4; cursor: pointer; box-shadow: inset 3px 0 0 #e6e9ed; background: #fff; }
  .ign-conta:hover { background: #f4f7f9; }
  .ign-conta-alerta { background: #fdf7f7; box-shadow: inset 3px 0 0 #c98080; }
  .ign-conta-alerta:hover { background: #fbeeee; }
  .ign-c-chevron { color: #6b747e; }
  .ign-c-nome { font-size: 13px; font-weight: 600; color: #1c2024; white-space: nowrap; }
  .ign-c-desc { font-size: 12px; color: #8a939c; margin-left: 6px; }
  .ign-c-qtde { font-size: 12.5px; color: #6b747e; text-align: right; }
  .ign-c-valor { font-size: 13px; font-weight: 600; text-align: right; }

  .ign-chip { display: inline-flex; align-items: center; gap: 6px; border-radius: 99px; padding: 3px 9px 3px 7px; font-size: 11.5px; }
  .ign-chip .fa-circle { font-size: 7px; }
  .ign-chip-ok { background: #f4faf7; border: 1px solid #b7e0cb; color: #0a6d4d; }
  .ign-chip-alerta { background: #fbeeee; border: 1px solid #e4c9c9; color: #a13c3c; }
  .ign-chip-info { background: #f4f7fb; border: 1px solid #c7d5e6; color: #3f5d80; }

  .ign-detalhe { background: #fbfcfd; border-bottom: 1px solid #e6e9ed; padding: 0 18px 10px 44px; }
  .ign-d-head, .ign-d-linha { display: grid; grid-template-columns: 1.5fr 110px 130px 1.6fr; gap: 10px; }
  .ign-d-head { padding: 8px 0 7px; border-bottom: 1px solid #e6e9ed; font-size: 10.5px; font-weight: 600; text-transform: uppercase; letter-spacing: .05em; color: #7b848e; }
  .ign-d-linha { padding: 8px 0; border-bottom: 1px solid #f2f4f6; font-size: 12.5px; color: #3b444d; align-items: start; }
  .ign-d-linha:hover { background: #f4f7f9; }
  .ign-d-hist { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .ign-d-det { font-size: 11.5px; color: #8a939c; margin-top: 3px; }
  .ign-tag { display: inline-block; border-radius: 4px; padding: 2px 7px; font-size: 11.5px; line-height: 1.5; }
  .ign-tag-neutra { background: #eef1f4; color: #5b6570; }
  .ign-tag-alerta { background: #fbeeee; color: #a13c3c; }
  .ign-d-rodape { display: flex; justify-content: space-between; gap: 16px; padding: 9px 0 2px; font-size: 11.5px; color: #8a939c; }

  .ign-vazio { flex: 1 1 auto; min-height: 0; display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 56px 20px; text-align: center; background: #fff; }
  .ign-vazio-t { font-size: 13.5px; font-weight: 600; color: #3b444d; }
  .ign-vazio-s { font-size: 12.5px; color: #8a939c; margin-top: 4px; }

  .ign-rodape {
    display: flex; justify-content: space-between; align-items: center; gap: 16px;
    margin-top: auto; padding: 12px 18px; background: #f7f9fa; border-top: 1px solid #dfe3e8;
    z-index: 5; box-shadow: 0 -2px 6px rgba(16,24,40,.06);
  }
  .ign-rodape-txt { font-size: 12px; color: #8a939c; }
  .ign-rodape-btns { display: flex; align-items: center; gap: 8px; }
  .ign-conta .btn-abrir { font-weight: 600; font-size: 12px; padding: 5px 12px; border-radius: 4px; white-space: nowrap; }
  .ign-conta .btn-abrir .fa { margin-left: 4px; transition: transform .15s; }
  .ign-conta .btn-abrir:hover .fa { transform: translateX(3px); }

  .ign-btn { display: inline-flex; align-items: center; gap: 7px; background: #fff; border: 1px solid #c6ccd4; border-radius: 5px; padding: 8px 14px; font-size: 12.5px; color: #3b444d; }
  .ign-btn:hover { background: #f4f6f8; }
  .ign-sair { background: #fdf1f1; border-color: #e4d7d7; color: #a13c3c; font-weight: 600; padding: 8px 18px; }
  .ign-sair:hover { background: #fbe7e7; border-color: #d9c2c2; }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/conciliacao-projeto/componentes/LinhasIgnoradasLista.vue